import { render, staticRenderFns } from "./RegionAddModal.vue?vue&type=template&id=142af28a&"
import script from "./RegionAddModal.vue?vue&type=script&lang=js&"
export * from "./RegionAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RegionAddModal.vue"
export default component.exports